import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LoginSettings } from '../loginSetting.model';
import { User } from '../../../shared-components/user/user.model';
import { System } from '../../../shared-components/System';

export function validateCurrentPassword(currentPass: string, loginSettings: LoginSettings, user?: User): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value != null) {
      if (control.value != currentPass) {
        if (control.value.toLowerCase() !== currentPass.toLowerCase() || (user.UserType == 1 && loginSettings.Student360StaffPasswordCaseSensitive == true) || loginSettings.PasswordCaseSensitive == true) {
          return { 'invalidCurrentPassword': true };
        }
      }
    }
    return null;
  };
}
export function validateCurrentPasswordV9(currentPass: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== undefined && control.value !== null && control.value !== currentPass) {
      return { 'invalidCurrentPassword': true };
    }
    return null;
  };
}
export const passwordsMatch: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const repeatNewPassword = control.get('repeatNewPassword');
  if (newPassword.value !== repeatNewPassword.value) {
    return { 'passwordsMustMatch': true };
  }
  return null;
};

export function passwordsMatchForChangePassword(loginSettings: LoginSettings, user?: User): ValidatorFn {
  return (control: FormGroup): ValidationErrors | null => {
    const newPassword = control.get('newPassword');
    const repeatNewPassword = control.get('repeatNewPassword');
    if (newPassword.value && repeatNewPassword.value) {
      if (newPassword.value !== repeatNewPassword.value) {
        if (!loginSettings.V10) {
          if ((user.UserType == 1 && loginSettings.Student360StaffPasswordCaseSensitive == true) || loginSettings.PasswordCaseSensitive == true || newPassword.value.toLowerCase() !== repeatNewPassword.value.toLowerCase()) {
            return { 'passwordsMustMatch': true };
          }
        }
        else {
          return { 'passwordsMustMatch': true };
        }
      }
    }
    return null;
  };
}

export function requiresUpperCase(loginSettings: LoginSettings): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const regexp = new RegExp('(?=.*[A-Z])');
    if (control.value !== undefined && !regexp.test(control.value) && loginSettings.V10 == true && loginSettings.PasswordRequiresUpper == true) {
      return { 'mustContainUpperCase': true };
    }
    return null;
  };
}

export function isValidEmail(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const regexp = System.mailRegexp;
    if (control.value !== undefined && !regexp.test(control.value)) {
      return { 'notValidEmail': true };
    }
    return null;
  };
}

export function requiresNumeric(loginSettings: LoginSettings): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const regexp = new RegExp('(?=.*[0-9])');
    if (control.value !== undefined && !regexp.test(control.value) && loginSettings.V10 == true && loginSettings.PasswordRequiresNumeric == true) {
      return { 'mustContainNumeric': true };
    }
    return null;
  };
}

export function requiresSpecial(loginSettings: LoginSettings): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const regexp = new RegExp('(?=.*[^a-zA-Z0-9+])');
    if (control.value !== undefined && !regexp.test(control.value) && loginSettings.V10 == true && loginSettings.PasswordRequiresSpecial == true) {
      return { 'mustContainSpecial': true };
    }
    return null;
  };
}

export function mustBeDifferent(user: User, loginSettings: LoginSettings): ValidatorFn {
  const currentPassword = user.Password;
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (loginSettings.V10 && control.value !== undefined && control.value == currentPassword) {
      return { 'mustBeDifferent': true };
    }

    if (!loginSettings.V10 && control.value !== undefined) {
      if (user.UserType == 1 && loginSettings.Student360StaffPasswordCaseSensitive == true && control.value == currentPassword) {
        return { 'mustBeDifferent': true };
      }
      else if (user.UserType == 1 && loginSettings.Student360StaffPasswordCaseSensitive == false && control.value && control.value.toLowerCase() === currentPassword.toLowerCase()) {
        return { 'mustBeDifferent': true };
      }
      else if (control.value && control.value.toLowerCase() === currentPassword.toLowerCase()) {
        return { 'mustBeDifferent': true };
      }
    }
    return null;
  };
}

export function notSameAsUsername(user: User, loginSettings: LoginSettings): ValidatorFn {
  const userName = user.UserName;
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== undefined && control.value == userName && loginSettings.PreventEqualPassUserName) {
      return { 'notSameAsUsername': true };
    }
    return null;
  };
}

export function requiresMixedLettersNumbers(loginSettings: LoginSettings, user?: User): ValidatorFn {
  const passwordFormat = /^(?=.*\d)(?=.*[A-Za-z])[0-9a-zA-Z_@./#!$%^&*+-]*$/;
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    if ((control.value !== undefined && control.value !== null) && !value.match(passwordFormat) && !loginSettings.V10 && (user ? user.UserType == 1 : true) && loginSettings.PasswordRequiresMixedLettersAndNumbers) {
      return { 'requiresMixedLettersNumbers': true };
    }
    return null;
  };
}

export function preventPasswordReuse(loginSettings: LoginSettings, user: User): ValidatorFn {
  const previousPasswords = user.ExpiredPasswords;
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== undefined && loginSettings.PreventPasswordReuse && previousPasswords.indexOf(control.value) > -1) {
      return { 'preventPasswordReuse': true };
    }
    return null;
  };
}
